import { IsString, IsOptional } from "class-validator";
import { IMoveUp } from "./move-up.interface";

export class CreateMoveUpDto
  implements
    Omit<
      IMoveUp,
      "_id" | "status" | "reversed_at" | "reversed_by" | "reverse_reason" | "created_by" | "createdAt" | "updatedAt"
    >
{
  @IsString()
  event_id: string;

  @IsString()
  dog_id: string;

  @IsString()
  show_id: string;

  @IsString()
  score_id: string;

  @IsString()
  from_element: string;

  @IsString()
  from_level: string;

  @IsOptional()
  @IsString()
  from_section?: string;

  @IsString()
  to_element: string;

  @IsString()
  to_level: string;

  @IsOptional()
  @IsString()
  to_section?: string;
}
